import React from "react";
import { MEDIA_URL } from '../../config/constants';
import { useTranslation } from "../../hooks/useTranslation";

const OurStory = () => {
  const { t } = useTranslation('home');

  return (
    <div className="our-story-section">
      <h2 className="our-story-heading">{t('story.title')}</h2>
      <div className="our-story-container">
        <div className="story-content">
          <img
            src={`${MEDIA_URL}/images/about/Our Story/Sun Catchers was born 2.webp`}
            className="story-image"
            alt="Sun Catchers founders"
          />
          <div className="story-text-container">
            <div className="story-text">
              <p>{t('story.paragraph1')}</p>
              <p>{t('story.paragraph2')}</p>
            </div>
            <div className="founders-info">
              <div className="founders-title">{t('story.foundedWith')}</div>
              <div className="founders-name">{t('story.teamName')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurStory;
